import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded';
import MobileStepper from '@mui/material/MobileStepper';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import React from 'react';
import { useTheme } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import SwipeableViews from 'react-swipeable-views';
import { autoPlay } from 'react-swipeable-views-utils';

interface InfoCarouselProps {
    data: any;
}
const AutoPlaySwipeableViews = autoPlay(SwipeableViews);
const InfoCarousel: React.FC<InfoCarouselProps> = ({ data }) => {
    const theme = useTheme();
    const navigate = useNavigate();
    const [activeStep, setActiveStep] = React.useState(0);

    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const handleStepChange = (step: number) => {
        setActiveStep(step);
    };

    return (
        <Paper sx={{ pt: 2, pr: 2, pl: 2, height: '100%' }} elevation={0}>
            <Grid container alignItems={'center'} spacing={2}>
                <Grid item>
                    <img src={data[activeStep].icon} alt="" height={30} />
                </Grid>
                <Grid item xs={10}>
                    <Typography
                        color={'primary'}
                        variant={'h6'}
                        sx={{ fontWeight: 'bold' }}
                    >
                        {data[activeStep].title}
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <Grid
                        container
                        direction={'column'}
                        justifyContent={'space-between'}
                        alignItems={'space-between'}
                        sx={{
                            height: window.location.href.includes('overview')
                                ? 260
                                : 175,
                            pt: 5,
                        }}
                    >
                        <Grid item>
                            <AutoPlaySwipeableViews
                                axis={
                                    theme.direction === 'rtl'
                                        ? 'x-reverse'
                                        : 'x'
                                }
                                index={activeStep}
                                onChangeIndex={handleStepChange}
                                enableMouseEvents
                                interval={6000}
                                autoplay={false}
                            >
                                {data.map((step, index) => (
                                    <Grid
                                        container
                                        key={step.title}
                                        spacing={1}
                                    >
                                        <Grid item>
                                            <Typography
                                                variant={'body2'}
                                                color={'primary'}
                                            >
                                                {step.description}
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                ))}
                            </AutoPlaySwipeableViews>
                        </Grid>
                        <Grid item>
                            {data[activeStep].buttonText && (
                                <Grid container justifyContent={'flex-end'}>
                                    <Grid item>
                                        <Button
                                            size={'small'}
                                            variant={'contained'}
                                            color={'primary'}
                                            endIcon={
                                                <ArrowForwardRoundedIcon />
                                            }
                                            onClick={() =>
                                                navigate(data[activeStep].url)
                                            }
                                            sx={{ mb: 2 }}
                                        >
                                            {data[activeStep].buttonText}
                                        </Button>
                                    </Grid>
                                </Grid>
                            )}
                            <MobileStepper
                                steps={data.length}
                                position="static"
                                activeStep={activeStep}
                                nextButton={
                                    <Button
                                        size="small"
                                        onClick={handleNext}
                                        disabled={
                                            activeStep === data.length - 1
                                        }
                                    >
                                        Next
                                        {theme.direction === 'rtl' ? (
                                            <KeyboardArrowLeft />
                                        ) : (
                                            <KeyboardArrowRight />
                                        )}
                                    </Button>
                                }
                                backButton={
                                    <Button
                                        size="small"
                                        onClick={handleBack}
                                        disabled={activeStep === 0}
                                    >
                                        {theme.direction === 'rtl' ? (
                                            <KeyboardArrowRight />
                                        ) : (
                                            <KeyboardArrowLeft />
                                        )}
                                        Back
                                    </Button>
                                }
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Paper>
    );
};

export default InfoCarousel;
